<template>
  <div class="page-container">
    <el-carousel height="585px">
      <el-carousel-item :interval="5000" arrow="always" v-for="item in bannerList" :key="item.index">
        <a class="slider-item" href="javascript:;">
          <img class="item-img" :src="item.src" />
        </a>
      </el-carousel-item>
    </el-carousel>
    <el-row>
      <el-col :span="12">
        <Panel class="panel-box-right" :title="'专场拍卖'" :route="{path:'/auction/index'}" :classes="'zc'">
          <Auction :list="specialList"></Auction>
        </Panel>
      </el-col>
      <el-col :span="12">
        <Panel class="panel-box-left" :title="'艺术资讯'" :route="{path:'/news/index'}" :classes="'zx'" >
          <div class="new-list" v-if="smallNewsList">
            <div v-if="smallNewsList.length>0">
              <div class="news-item new-item-small" v-for="(item,index) in smallNewsList" :key="index">
                <div class="news-item-link">
                  <span class="ranklist rankround" :class="'ranklist'+(index+1)">{{index+1}}</span>
                  <div class="title-row">
                    <router-link :to="{path:'/news/detail',query:{id:item.id}}" class="title">{{item.title}}</router-link>
                    <span class="news-price">资讯 1元/条</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="defaultNewsList.length>0">
              <div class="news-item new-item-default" v-for="(item,index) in defaultNewsList" :key="index">
                <div class="news-item-link">
                  <div class="picture">
                    <div class="img"  :style="'background-image:url('+ item.faceimage+')'"></div>
                  </div>
                  <div class="info">
                    <div class="title-row">
                      <router-link :to="{path:'/news/detail',query:{id:item.id}}" class="title">{{item.title}}</router-link>
                      <span class="news-price">资讯 1元/条</span>
                    </div>
                    <div class="info-tools">
                      <span class="time">{{item.createtime}}</span>
                      <span class="comment"><span class="comment-item"><i>{{item.userLikeCount}}</i></span><span class="comment-item"><i>{{item.commentCount}}</i></span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Panel>
      </el-col>
    </el-row>
    <section>
      <Panel :title="'大家拍'" :classes="'dajp'" :route="{path:'/everybody/index'}">
        <div class="pro-list">
          <swiper :options="swiperOption" class="artbox-ul">
            <swiper-slide v-for="(item,index) in everybodyList" :key="index">
              <div class="pro-item">
                <router-link :to="{path:'/auction/item',query:{id:item.id}}" class="pro-item-link">
                  <div class="imgbox"><img :src="item.photo"> </div>
                  <div class="title ">{{item.product_name}}</div>
                </router-link>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </Panel>
    </section>
    <section>
      <Panel :title="'艺术家'" :route="{path:'/artist/index'}" :classes="'artist'">
        <div class="art-list">
          <el-row>
            <el-col :span="3" v-for="(item,index) in artistList" :key="index">
              <router-link :to="{path:'/artist/page',query:{id:item.id}}" class="art-item">
                <div class="imgbox">
                  <img :src="item.headimg" :alt="item.Realname">
                </div>
                <p class="name">{{item.Realname}}</p>
              </router-link>
            </el-col>
          </el-row>
        </div>
      </Panel>
    </section>
  </div>
</template>
<style lang="scss">
.panel-box-left {
  margin-left: 40px;
}
.panel-box-right::before {
  content: "";
  display: block;
  position: absolute;
  right: -40px;
  top: 0;
  width: 1px;
  height: 98%;
  border-left: 1px dashed rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.2);
  z-index: 2;
  transform: translate(-50%, 0);
  transform-origin: 0 0;
}
.panel-box-right {
  margin-right: 40px;
  position: relative;
}
</style>
<style lang="scss" scoped>
@import "../../assets/news.scss";
.slider-item {
  position: relative;
  overflow: hidden;
  display: block;
  .item-img {
    width: 100%;
    height: 100%;
  }
}

.news-item-link {
  position: relative;
}
.news-item-link .title-row {
  position: relative;
  padding-right: 90px; /* 预留标签空间，避免与标题重叠 */
}
.news-item-link .title-row .news-price {
  position: absolute;
  right: 0;
  bottom: 0;
  color: #bc230c;
  font-size: 14px;
  white-space: nowrap;
}

.xt-panel .title-sub {
  display: flex;
  display: -webkit-box;
  display: -webkit-flex;
  justify-content: space-around;
  -webkit-justify-content: space-around;
  align-items: center;
  -webkit-align-items: center;
  border-bottom: 1px solid #ddd;
}

// 大家拍
.pro-list {
  margin-top: 15px;
  .pro-item {
    padding: 0 10px;
    overflow: hidden;
    .pro-item-link {
      display: block;
      position: relative;
      .imgbox {
        cursor: pointer;
        padding-top: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 200px auto;
        overflow: hidden;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          -o-transform: translate(-50%, -50%);
          display: block;
          width: 100%;
        }
      }
      .title {
        width: 100%;
        height: 48px;
        background-color: rgba(38, 38, 38, 0.6);
        color: #fff;
        font-size: 20px;
        line-height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}
.art-list {
  margin-top: 10px;
  .art-item {
    .imgbox {
      width: 130px;
      height: 130px;
      background-color: #dddddd;
      border-radius: 65px;
      overflow: hidden;
      position: relative;
      margin: 0 auto;
      img {
        width: 120px;
        height: 120px;
        text-align: center;
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -60px;
        margin-top: -60px;
        border-radius: 60px;
      }
    }
    .name {
      text-align: center;
      margin-top: 14px;
      font-size: 18px;
      color: #333;
    }
  }
}
</style>
<script>
import Panel from '../../components/panel.vue';
import Auction from '../../components/auctionlist.vue';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import {
  Home
} from "../../model/home.js";
let home = new Home();
export default {
  name: 'index',
  data() {
    return {
      bannerList: [
        { src: require('../../assets/image/banner1.png'), index: 'ddd0' },
        { src: require('../../assets/image/download.jpg'), index: 'ddd2' }
      ],
      auctionMenu: [
        { name: "竞拍中" },
        { name: "预拍中" },
        { name: "已结束" }
      ],
      newsMenu: [
        { name: "资讯" },
        { name: "展览" }
      ],
      dajipMenu: [
        { id: 1, name: '全部' },
        { id: 2, name: '山水' },
      ],
      banner: [],
      everybodyList: [],
      artistList: [],
      specialList: [],
      newList: [],
      smallNewsCount: 5,//小型资讯显示数量
      swiperOption: {
        spaceBetween: 0,
        slidesPerView: 4,
        autoplay: 5000,
        autoplayDisableOnInteraction: true,
        watchSlidesProgress: true,    //开启这个参数来计算每个slide的progress(进度、进程)
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      }
    }
  },
  components: {
    Auction,
    Panel,
    swiper,
    swiperSlide
  },
  computed: {
    smallNewsList: {
      get: function () {
        if (this.newList.length < this.smallNewsCount) {
          return this.newList
        }
        let newArr = []
        for (var i = 0; i < this.smallNewsCount; i++) {
          let item = this.newList[i]
          newArr.push(item)
        }
        return newArr

      },
      set: function (val) {
        this.smallNewsList = val
      }
    },
    defaultNewsList: {
      get: function () {
        if (this.newList.length < this.smallNewsCount) {
          return []
        }
        let newArr = this.newList.slice(this.smallNewsCount)
        return newArr
      },
      set: function (val) {
        this.defaultNewsList = val
      }
    }
  },
  methods: {
    setHomePageData() {
      let _this = this;
      return new Promise(function (resolve, reject) {
        home.webHomePage({
          SpecialCount: 3,
          InformationCount: 10,
          EverybodyCount: 10,
          ArtistCount: 8
        }).then((res) => {
          _this.banner = res.Banner;
          _this.artistList = res.Author;
          _this.everybodyList = res.Everybodys;
          _this.newList = res.M_Infomation;
          _this.specialList = res.Specials;
          resolve();
        }, () => {
          reject();
        })
      });
    }
  },
  created() {
    this.setHomePageData()
  }
}
</script>